@if ((selectCashflowByScenarioType | async); as cashflows) {
    <div class="cashflow-table-scroll-wrapper">
        <table mat-table [dataSource]="cashflows.records">
            <ng-container matColumnDef="date" sticky>
                <th mat-header-cell *matHeaderCellDef>Date</th>
                <td mat-cell *matCellDef="let element">{{ element.date | date }}</td>
                <td mat-footer-cell *matFooterCellDef>Total</td>
            </ng-container>
            <ng-container matColumnDef="fundAgeInQuarters">
                <th mat-header-cell *matHeaderCellDef>Fund Age in Quarters</th>
                <td mat-cell *matCellDef="let element">{{ element.fundAgeInQuarters }}</td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>
            <ng-container matColumnDef="assetDistribution">
                <th mat-header-cell *matHeaderCellDef>Asset Distributions</th>
                <td mat-cell *matCellDef="let element" (click)="element?.assetDistribution !== 0 && openPopup(element, ['DISTRIBUTION', 'EXIT'])"
                    [ngStyle]="{'cursor': element?.assetDistribution !== 0 ? 'pointer' : 'default'}">
                    {{ element?.assetDistribution | decimalFormat: "currency" }}
                </td>
                <td mat-footer-cell *matFooterCellDef>{{ cashflows?.totalAssetDistribution | decimalFormat: "currency" }}</td>
            </ng-container>
            <ng-container matColumnDef="assetDistributionTopDownPattern">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                    <span class="pattern">{{ getTopDownPattern(element) }}</span>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>
            <ng-container matColumnDef="assetDrawdown">
                <th mat-header-cell *matHeaderCellDef>Asset Drawdowns</th>
                <td mat-cell *matCellDef="let element" (click)="element?.assetDrawdown !== 0 && openPopup(element, ['INJECTION'])"
                    [ngStyle]="{'cursor': element?.assetDrawdown !== 0 ? 'pointer' : 'default'}">
                    {{ element?.assetDrawdown | decimalFormat: "currency" }}
                </td>
                <td mat-footer-cell *matFooterCellDef>{{ cashflows?.totalAssetDrawdown | decimalFormat: "currency" }}</td>
            </ng-container>
            <ng-container matColumnDef="gpManagementFee">
                <th mat-header-cell *matHeaderCellDef>Management Fees</th>
                <td mat-cell *matCellDef="let element">
                    {{ element?.gpManagementFee?.amount | decimalFormat: "currency" }}
                </td>
                <td mat-footer-cell *matFooterCellDef>{{ cashflows?.totalGpManagementFee | decimalFormat: "currency" }}</td>
            </ng-container>
            <ng-container matColumnDef="gpManagementFeePattern">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                    <span class="pattern">{{ element?.gpManagementFee?.pattern }}</span>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>
            <ng-container matColumnDef="gpUnfundedPayment">
                <th mat-header-cell *matHeaderCellDef>Unfunded Drawdowns</th>
                <td mat-cell *matCellDef="let element">
                    {{ element?.gpUnfundedPayment?.amount | decimalFormat: "currency" }}
                </td>
                <td mat-footer-cell *matFooterCellDef>{{ cashflows?.totalGpUnfundedPayment | decimalFormat: "currency" }}</td>
            </ng-container>
            <ng-container matColumnDef="gpUnfundedPaymentPattern">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                    <span class="pattern">{{ element?.gpUnfundedPayment?.pattern }}</span>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>
            <ng-container matColumnDef="gpUnfundedDistribution">
                <th mat-header-cell *matHeaderCellDef>Unfunded Distributions</th>
                <td mat-cell *matCellDef="let element">
                    {{ element?.gpUnfundedDistribution?.amount | decimalFormat: "currency" }}
                </td>
                <td mat-footer-cell *matFooterCellDef>{{ cashflows?.totalGpUnfundedDistribution | decimalFormat: "currency" }}</td>
            </ng-container>
            <ng-container matColumnDef="gpUnfundedDistributionPattern">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                    <span class="pattern">{{ element?.gpUnfundedDistribution?.pattern }}</span>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>
            <ng-container matColumnDef="gpUnfundedNet">
                <th mat-header-cell *matHeaderCellDef>Unfunded Net</th>
                <td mat-cell *matCellDef="let element">{{ element?.gpUnfundedNet | decimalFormat: "currency" }}</td>
                <td mat-footer-cell *matFooterCellDef>{{ cashflows?.totalGpUnfundedNet | decimalFormat: "currency" }}</td>
            </ng-container>
            <ng-container matColumnDef="purchasePrice">
                <th mat-header-cell *matHeaderCellDef>Purchase Price</th>
                <td mat-cell *matCellDef="let element">{{ element?.purchasePrice | decimalFormat: "currency" }}</td>
                <td mat-footer-cell *matFooterCellDef>{{ cashflows?.totalPurchasePrice | decimalFormat: "currency" }}</td>
            </ng-container>
            <ng-container matColumnDef="gpGross">
                <th mat-header-cell *matHeaderCellDef>Gross Cash Flows</th>
                <td mat-cell *matCellDef="let element">{{ element?.gpGross | decimalFormat: "currency" }}</td>
                <td mat-footer-cell *matFooterCellDef>{{ cashflows?.totalGpGross | decimalFormat: "currency" }}</td>
            </ng-container>
            <ng-container matColumnDef="gpCarryNet">
                <th mat-header-cell *matHeaderCellDef>Net Cash Flows for Carry</th>
                <td mat-cell *matCellDef="let element">
                    {{ element?.gpCarryNet | decimalFormat: "currency" }}
                </td>
                <td mat-footer-cell *matFooterCellDef>{{ cashflows?.totalGpCarryNet | decimalFormat: "currency" }}</td>
            </ng-container>
            <ng-container matColumnDef="gpCarryPayment">
                <th mat-header-cell *matHeaderCellDef>Carry Payments</th>
                <td mat-cell *matCellDef="let element">
                    {{ element?.gpCarryPayment?.amount | decimalFormat: "currency" }}
                </td>
                <td mat-footer-cell *matFooterCellDef>{{ cashflows?.totalGpCarryPayments | decimalFormat: "currency" }}</td>
            </ng-container>
            <ng-container matColumnDef="gpCarryPaymentHurdle">
                <th mat-header-cell *matHeaderCellDef>Hurdle</th>
                <td mat-cell *matCellDef="let element">
                    <span class="pattern">{{ element?.gpCarryPayment?.hurdle | decimalFormat: "currency" }}</span>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>
            <ng-container matColumnDef="secondaryCashflow">
                <th mat-header-cell *matHeaderCellDef>Total Secondary Cashflows</th>
                <td mat-cell *matCellDef="let element">{{ element?.secondaryCashflow | decimalFormat: "currency" }}</td>
                <td mat-footer-cell *matFooterCellDef>{{ cashflows?.totalSecondaryCashflow | decimalFormat: "currency" }}</td>
            </ng-container>
            <ng-container matColumnDef="secondaryManagementFee">
                <th mat-header-cell *matHeaderCellDef>Secondary Management Fee</th>
                <td mat-cell *matCellDef="let element">
                    {{ element?.secondaryManagementFee?.amount | decimalFormat: "currency" }}
                </td>
                <td mat-footer-cell *matFooterCellDef>{{ cashflows?.totalSecondaryManagementFee | decimalFormat: "currency" }}</td>
            </ng-container>
            <ng-container matColumnDef="secondaryManagementFeePattern">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                    <span class="pattern">{{ element?.secondaryManagementFee?.pattern }}</span>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>
            <ng-container matColumnDef="secondaryCarryNet">
                <th mat-header-cell *matHeaderCellDef>Secondary Net Cash Flows for Carry</th>
                <td mat-cell *matCellDef="let element">
                    {{ element?.secondaryCarryNet | decimalFormat: "currency" }}
                </td>
                <td mat-footer-cell *matFooterCellDef>{{ cashflows?.totalSecondaryCarryNet | decimalFormat: "currency" }}</td>
            </ng-container>
            <ng-container matColumnDef="secondaryCarryPayment">
                <th mat-header-cell *matHeaderCellDef>Secondary Carry Payments</th>
                <td mat-cell *matCellDef="let element">
                    {{ element?.secondaryCarryPayment?.amount | decimalFormat: "currency" }}
                </td>
                <td mat-footer-cell *matFooterCellDef>{{ cashflows?.totalSecondaryCarryPayment | decimalFormat: "currency" }}</td>
            </ng-container>
            <ng-container matColumnDef="secondaryCarryPaymentHurdle">
                <th mat-header-cell *matHeaderCellDef>Hurdle</th>
                <td mat-cell *matCellDef="let element">
                    <span class="pattern">{{ (element?.secondaryCarryPayment?.hurdle  | decimalFormat: "currency") }}</span>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>
            <ng-container matColumnDef="secondaryNetCashflow">
                <th mat-header-cell *matHeaderCellDef>Total Net Secondary Cashflows</th>
                <td mat-cell *matCellDef="let element">{{ element?.secondaryNetCashflow | decimalFormat: "currency" }}</td>
                <td mat-footer-cell *matFooterCellDef>{{ cashflows?.totalSecondaryNetCashflow | decimalFormat: "currency" }}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>
            <tr mat-footer-row *matFooterRowDef="displayColumns; sticky: true" class="row-important row-top-border"></tr>
        </table>
    </div>
}

<ng-template #popupTemplate let-data>
    @let currency = currency$ | async;
    <div class="dialog-header">
        <h4 mat-dialog-title>{{ data.title }}{{ currency ? ' (' + currency + ')' : '' }}</h4>
        <button mat-icon-button mat-dialog-close class="dialog-close" aria-label="Close" data-test="dialog-close">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="dialog-toolbar">
        <mat-form-field appearance="outline" class="column-picker" subscriptSizing="dynamic">
            <mat-label>Columns</mat-label>
            <mat-select multiple [value]="selectedColumns" (valueChange)="onColumnPickerChange($event)">
                <mat-select-trigger>{{ selectedColumns.length }} selected</mat-select-trigger>
                @for (col of DIALOG_COLUMNS; track col) {
                    <mat-option [value]="col">{{ DIALOG_COLUMN_LABELS[col] }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>
    <mat-dialog-content>
        <div class="weighted-breakdown">
            <table class="scenario-table">
                <thead>
                <tr>
                    <th class="company-col"></th>
                    @if (selectedColumns.includes('low')) {
                        <th class="scn-col scn-low">LOW<span class="scn-prob">{{ data.lowProbability | percent }}</span></th>
                    }
                    @if (selectedColumns.includes('base')) {
                        <th class="scn-col scn-base">BASE<span class="scn-prob">{{ data.baseProbability | percent }}</span></th>
                    }
                    @if (selectedColumns.includes('high')) {
                        <th class="scn-col scn-high">HIGH<span class="scn-prob">{{ data.highProbability | percent }}</span></th>
                    }
                    @if (selectedColumns.includes('weighted')) {
                        <th class="scn-col scn-weighted">Weighted</th>
                    }
                </tr>
                </thead>
                <tbody>
                    @for (asset of data.breakdown.assetBreakdowns; track asset.assetId ?? asset.assetName) {
                        <tr>
                            <td class="company-col">
                                @if (asset.assetId) {
                                    <a (click)="navigateToAssetById(asset.assetId)" class="detail-asset-link">{{ asset.assetName }}</a>
                                } @else {
                                    <span class="detail-asset-placeholder">{{ asset.assetName }}</span>
                                }
                                @for (type of asset.cashflowTypes; track type) {
                                    <span class="cashflow-type-chip"
                                          [ngClass]="{
                                              'cashflow-type-distribution': type === 'DISTRIBUTION',
                                              'cashflow-type-exit':         type === 'EXIT',
                                              'cashflow-type-injection':    type === 'INJECTION'
                                          }">{{ type }}</span>
                                }
                            </td>
                            @if (selectedColumns.includes('low')) {
                                <td class="scn-col scn-low">
                                    <span class="cell-amount">{{ asset.lowAmount | decimalFormat: "currency" }}</span>
                                    <span class="cell-pct">{{ asset.lowPercent | number: '1.1-1' }}%</span>
                                </td>
                            }
                            @if (selectedColumns.includes('base')) {
                                <td class="scn-col scn-base">
                                    <span class="cell-amount">{{ asset.baseAmount | decimalFormat: "currency" }}</span>
                                    <span class="cell-pct">{{ asset.basePercent | number: '1.1-1' }}%</span>
                                </td>
                            }
                            @if (selectedColumns.includes('high')) {
                                <td class="scn-col scn-high">
                                    <span class="cell-amount">{{ asset.highAmount | decimalFormat: "currency" }}</span>
                                    <span class="cell-pct">{{ asset.highPercent | number: '1.1-1' }}%</span>
                                </td>
                            }
                            @if (selectedColumns.includes('weighted')) {
                                <td class="scn-col scn-weighted">
                                    <span class="cell-amount">{{ asset.weightedAmount | decimalFormat: "currency" }}</span>
                                    <span class="cell-pct">{{ asset.weightedPercent | number: '1.1-1' }}%</span>
                                </td>
                            }
                        </tr>
                    }
                </tbody>
                <tfoot>
                <tr class="weighted-footer-row">
                    <td class="company-col">Total</td>
                    @if (selectedColumns.includes('low')) {
                        <td class="scn-col scn-low">
                            <span class="cell-amount">{{ data.breakdown.lowTotal | decimalFormat: "currency" }}</span>
                            <span class="cell-pct">100.0%</span>
                        </td>
                    }
                    @if (selectedColumns.includes('base')) {
                        <td class="scn-col scn-base">
                            <span class="cell-amount">{{ data.breakdown.baseTotal | decimalFormat: "currency" }}</span>
                            <span class="cell-pct">100.0%</span>
                        </td>
                    }
                    @if (selectedColumns.includes('high')) {
                        <td class="scn-col scn-high">
                            <span class="cell-amount">{{ data.breakdown.highTotal | decimalFormat: "currency" }}</span>
                            <span class="cell-pct">100.0%</span>
                        </td>
                    }
                    @if (selectedColumns.includes('weighted')) {
                        <td class="scn-col scn-weighted">
                            <span class="cell-amount">{{ data.breakdown.weightedTotal | decimalFormat: "currency" }}</span>
                            <span class="cell-pct">100.0%</span>
                        </td>
                    }
                </tr>
                </tfoot>
            </table>
        </div>
    </mat-dialog-content>
</ng-template>
